// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__6e9OI","spinner":"styles_spinner__Xp_RE"};